function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#00267f",
  d: "M0 0h640v480H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffc726",
  d: "M213.3 0h213.4v480H213.3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "bb_svg__a",
  d: "M319.8 135.5c-7 19-14 38.6-29.2 53.7 4.7-1.6 13-3 18.2-2.8v79.5l-22.4 3.3c-.8 0-1-1.3-1-3-2.2-24.7-8-45.5-14.8-67-.5-2.9-9-14-2.4-12 .8 0 9.5 3.6 8.2 1.9a85 85 0 00-46.4-24c-1.5-.3-2.4.5-1 2.2 22.4 34.6 41.3 75.5 41.1 124 8.8 0 30-5.2 38.7-5.2v56.1H320l2.5-156.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("use", {
  width: "100%",
  height: "100%",
  transform: "matrix(-1 0 0 1 639.5 0)",
  xlinkHref: "#bb_svg__a"
});

var SvgBb = function SvgBb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgBb;